import { useQuery } from '@tanstack/react-query';
import { groupBy } from 'lodash-es';
import { selfServiceClient } from '../services/selfService';
import { createLicenseModel } from './createLicenseModel';
import { sortLicenseModelFn } from './sortLicenseModelFn';

export const licensesQueryKey = 'subscriptions';

export const useLicences = (options?: { keepPreviousData: boolean }) =>
  useQuery({
    queryKey: [licensesQueryKey],
    queryFn: async () => {
      const result = await selfServiceClient.getAllSubscriptions();

      return Object.entries(groupBy(result.subscriptions, 'License_Id__c'))
        .map((data) => createLicenseModel(...data))
        .sort(sortLicenseModelFn);
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    ...options,
  });
